import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase, Sorting, SortDirection } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { MemberService, IMemberSearchFilters, AddressSystemCode } from 'app/cd/services/member-service';
import { apiCall } from 'app/shared/lib/api/api';
import { EssPagerCustomElement } from 'app/shared/elements/ess-pager';
import { SortChangeEvent } from 'app/shared/attributes/sortable-attribute';
import { IQueryLoadOptions } from 'app/shared/lib/api/api-types';
import * as CD from 'app/cd/models/essette-api';

@autoinject()
export class MemberAlternateAddresses extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.stringNull({ defaultBindingMode: bindingMode.toView, changeHandler: 'reload' })
    public memberId: string | null = null;

    protected memberAlternateAddresses: ReadonlyArray<CD.MemberAddress> = [];

    private sorting: Sorting = new Sorting();
    protected resultCount: number = 0;
    protected pageSize: number = 25;

    ////****************** Element References ***************************************////
    protected $pager!: EssPagerCustomElement;

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(private readonly memberService: MemberService,
        ...rest: any[]) {
        super(...rest);

        // Default Sort
        this.sorting.entries = [
            {
                reference: 'type.description',
                direction: SortDirection.Ascending
            }
        ];
    }

    ////****************** Events ***************************************************////
    protected async reload(): Promise<void> {
        await this.loadMemberAddresses();
    }

    /** Handles the grid's sort event */
    protected applySort(event: SortChangeEvent): void {
        const { property, direction } = event.detail;
        const { sorting } = this;
        if(direction === null) {
            sorting.remove(property);
        } else {
            sorting.add({
                reference: property,
                direction: direction === 'asc' ? SortDirection.Ascending : SortDirection.Descending
            });
        }
        this.reload();
        //Call stop Propagation to prevent parent table from reload and losing sort
        event.stopPropagation();
    }

    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadMemberAddresses(): Promise<void> {
        if(!this.memberId) return;

        const options: Partial<IQueryLoadOptions> = {
            includeInactive: false,
            sorting: this.sorting,
            page: this.$pager?.page || 0,
            top: this.pageSize
        };

        const includes = [
            'region',
            'type'
        ];

        const fields = [
            'city',
            'description',
            'postalCode',
            'region.description',
            'street1',
            'street2',
            'type.description'
        ];

        const searchFilters: IMemberSearchFilters = {
            alternateTypes: true
        }

        try {
            this.state.beginLoad();

            const response = await this.memberService.loadMemberAddresses(this.memberId, AddressSystemCode.All, options, includes, fields, searchFilters);
            this.memberAlternateAddresses = response.results;
            this.resultCount = response.count || 0;
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }
}
